import {COMPETENT_AUTHORITIES, RECOMMENDATION_URL} from "@/services/endpoints";
import http from "@/services/http";

export function  getCompetentAuthorities(params) {
  return http.request({
    url: 'api/public/competent-authorities',
    method:'get',
    params
  })
}
export function  fetchCompetentAuthority(id) {
  return http.request({
    url:COMPETENT_AUTHORITIES + `/${id}`,
    method:'get',
  })
}
export function createCompetentAuthority(postData){
  return http.request({
    url:COMPETENT_AUTHORITIES,
    method:'post',
    data:postData
  })
}
export function updateCompetentAuthority(id, postData){
  return http.request({
    url:COMPETENT_AUTHORITIES + `/${id}`,
    method:'put',
    data:postData
  })
}
export function deleteCompetentAuthority(id){
  return http.request({
    url:COMPETENT_AUTHORITIES + `/${id}`,
    method:'delete',
  })
}
export function activateCompetentAuthority(id) {
  return http.request({
    url:COMPETENT_AUTHORITIES+`/${id}/activate`,
    method:'put',
  })
}
export function deactivateCompetentAuthority(id) {
  return http.request({
    url:COMPETENT_AUTHORITIES+`/${id}/deactivate`,
    method:'put',
  })
}
